<template>
  <div class="assign-status-dialog-container">
    <div class="assign-status">
      <v-row>
        <v-col cols="12">
          <h3>Confirm Pending Assignments</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-data-table
            :items="actions"
            :headers="headers"
            :hide-default-footer="true"
          >
            <template  
              v-slot:item.status="{ item }"
            >
              <v-icon 
                v-if="item.status == 'false'"
                color="red"
              >
                mdi-close
              </v-icon>

              <v-icon 
                v-if="item.status == 'true'"
                color="green"
              >
                mdi-check
              </v-icon>

              <v-progress-circular
                v-if="item.status == 'init' && loading"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </template>

            <template  
              v-slot:item.target="{ item }"
            >
              <span
                v-if="item.isDir"
              >
                {{ item.updatedVehicleName }}
              </span>

              <span 
                v-else
              >
                {{ item.target }}
              </span>
            </template>

            <template  
              v-slot:item.parent="{ item }"
            >
              <span >
                {{ returnVehicleGroup(item.parent, nodes).metadata.label }}
              </span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col  v-for="(err, index) in errors" :key="index" cols="12">
          <div class="error-message">
            {{ err }}
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="auto"
          class="mr-auto"
        >
          <v-btn 
            v-if="!completed"
            text 
            class="ctrl-btn cancel" 
            @click="closeWindow"
          >
            BACK
          </v-btn>
          <v-btn 
            v-else
            text 
            class="ctrl-btn cancel" 
            @click="closeAll"
          >
            DONE
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn 
            v-if="!loading" 
            text 
            class="ctrl-btn submit" 
            :disabled="completed || actions.length == 0"
            @click="submit" 
          >
            CONFIRM
          </v-btn>
          <v-progress-circular
            v-else
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>


import { Logger } from "aws-amplify"
const logger = new Logger("Assign Status")

import { AssignDeviceToVehicle, UnassignDeviceFromVehicle, CreateOrgVehicle } from "@/services/API.js";

export default {
  name: 'AssignmentStatus',
  props: {
    actions: {
      type: Array,
      required: true
    },
    org: {
      type: String,
      required: true
    },
    nodes: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Source Install Tag',
          value: 'install_tag',
          align: 'left'
        },
        {
          text: 'Destination Vehicle',
          value: 'target',
          align: 'left'
        },
        {
          text: 'Destination Group',
          value: 'parent',
          align: 'left'
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left'
        },
      ],
      parsedActions: [],
      loading: false,
      completed: false,
      errors: []
    }
  },
  methods: {
    closeWindow(){
      if(this.completed) {
        this.$emit('clearQue');
      }
      this.$emit('closeAssignmentStatus')
    },
    closeAll() {
      this.$emit('clearQue');
      this.$emit('closeAllAssignmentWindows')
    },
    submit() {
      this.loading = true;
      const promises = [];

      for (let i = 0; i < this.actions.length; i++) {
        let device = this.actions[i];

        // Check if target is a folder/group 
        logger.info('device is here : ', device);
        if (device.isDir) {
          // Create new vehicle then assign device
          promises.push(this.createVehicle(device));
        }
        else if (device.hasDevice.length > 0) {
          promises.push(this.unassginDevice(device));
        } 
        else {
          promises.push(this.assignDevice(device));
        }
      }

      Promise.all(promises)
      .then(res => {
        if(res) {
          this.loading = false;
          this.completed = true;

          this.$emit('assignmentSubmited')
        }
      })
      .catch(err => {
        this.errors.push(err);
        this.loading = false;
      })
    },

    createVehicle(device) {
      const param = {
        org: this.org,
        nodeId: device.parent,
        vehicleType: 'car',
        vehicleName: device.updatedVehicleName != device.install_tag ? device.updatedVehicleName : device.install_tag
      }
      return new Promise (async (resolve, rej) => {
        CreateOrgVehicle(this.org, param)
        .then(res => {
          if (res) {
            device.vehicleId = res.id
            this.assignDevice(device)
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              rej(false)
            })
          }
        })
        .catch(err => {
          if (err) {
            this.updateStatus(device.id, 'false')
            rej(false);
          }
        });
      });
    },

    assignDevice(device) {
      logger.info('assign device : ', device)
      const param = {
        deviceId: device.id
      };
      return new Promise (async (resolve, rej) => {
        AssignDeviceToVehicle(this.org, device.vehicleId, param)
        .then(res => {
          if (res.deviceId) {
            logger.info('attempting to update status : ', device)
            this.updateStatus(device.id, 'true')

            resolve(true);
          }
        })
        .catch(err => {
          if (err) {
            this.updateStatus(device.id, 'false')

            rej(false);
          }
        });
      });
    },

    async unassginDevice(device) {
      let deviceObjs = device.hasDevice;

      for (const item in deviceObjs) {
        let deviceId = deviceObjs[item].device_id;
        
        const unassign = await UnassignDeviceFromVehicle(this.org, device.vehicleId, deviceId);

        if (unassign) {
          this.assignDevice(device)
          .then(() => {
            logger.info('attempting to update status : ', device)
            this.updateStatus(device.id, 'true')

            return true;
          })
          .catch(err => {
            this.updateStatus(device.id, 'false')
            logger.info('err : ', err);

            return false;
          })
        }
      }
    },

    updateStatus(id, status) {
      for (var i in this.actions) {
        if (this.actions[i].id == id) {
            this.actions[i].status = status;

            break;
        }
      }
    },

    returnVehicleGroup(id, node) {
				let result;

				if (Object.values(node).indexOf(id) > -1) {
					return node;
				} else {
					for (var i = 0; i < node.nodes.length; i += 1) {
						let subNode = node.nodes[i];
						
						result = this.returnVehicleGroup(id, subNode);

						if (result !== false) {
								return result;
						}
					}
					return false;
				}
			},
  }
}
</script>

<style lang="scss" scoped>
  .assign-status-dialog-container {
    z-index: 9999;
    position: fixed;
    left: 0%;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4) !important;
    width: 100vw;
    height: 100vh;
    .assign-status {
      background: white;
      margin: 0;
      position: relative;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 0;
      overflow: hidden;
      border: solid 2px;
      width: 1000px;
      padding: 1em;
      .header {
        background: #e0e0e0;
        border: solid 1px;
        text-align: center;
        padding: 0;
      }
      .org-select {
        padding-left: 1em;
      }
      .ctrl-btn {
        font-size: 20px;
        padding-bottom: .25em;
        padding-bottom: .25em;
        color: #0069bb;
        &:hover {
          cursor: pointer;
        }
      }
      .cancel {
        padding-left: 1em;
      }
      .submit {
        padding-right: 1em;
      }
    }
    .error-message {
      color: red !important;
      padding-left: 1em;
    }
    .close-icon {
      top: 0;
      right: 0;
      position: absolute;
    }
  }
</style>